import MuiIconButton from './MuiIconButton';
import MuiAppBar from './MuiAppBar';
import MuiDrawer from './MuiDrawer';
import MuiContainer from './MuiContainer';
import MuiPopover from './MuiPopover';
import MuiMenuItem from './MuiMenuItem';


const overrides ={
    MuiIconButton,
    MuiAppBar,
    MuiDrawer,
    MuiContainer,
    MuiPopover,
    MuiMenuItem
};

export default overrides;
